import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postReply (data) {

	try {

		const url = `${baseURI}/replies/`;
		const response = await baseAPIRequest({
			url,
			data,
			params: { method: 'POST' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to create reply: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postReply;
